import { FC, ReactNode } from "react";
import { IconContract, IconExpand } from "./CollapsibleHeader.ui";
import {
  StyledCollapsibleHeader,
  CollapsibleHeaderContent,
  CollapsibleHeaderAddContent,
  IconClickableArea,
} from "./CollapsibleHeader.ui";

export enum CollapsibleHeaderTestIds {
  Component = "collapsible-header",
  Title = "collapsible-header_title",
}

type Props = {
  id?: string;
  className?: string;
  isOpen: boolean;
  onAddContent: () => void;
  onIconClick: () => void;
  testId?: string;
  title: ReactNode;
};

export const CollapsibleHeader: FC<Props> = ({
  id,
  className,
  title,
  isOpen,
  onAddContent,
  onIconClick,
  children,
  testId,
}) => {
  return (
    <StyledCollapsibleHeader
      id={id}
      className={className}
      data-testid={testId ?? CollapsibleHeaderTestIds.Component}
    >
      <CollapsibleHeaderContent>
        {isOpen ? (
          children ?? (
            <CollapsibleHeaderAddContent onAddContent={onAddContent} />
          )
        ) : (
          <div
            data-testid={
              testId ? `${testId}_title}` : CollapsibleHeaderTestIds.Title
            }
          >
            {title}
          </div>
        )}
      </CollapsibleHeaderContent>
      <IconClickableArea onClick={onIconClick}>
        {isOpen ? <IconContract /> : <IconExpand />}
      </IconClickableArea>
    </StyledCollapsibleHeader>
  );
};
